<div class="quick-order-form">
  <form
    [formGroup]="form"
    class="quick-order-form-container"
  >
    <div
      class="quick-order-form-input"
      role="search"
      [attr.aria-label]="'quickOrderForm.quickOrderSearch' | cxTranslate"
    >
      <input
        (focus)="open()"
        (blur)="onBlur($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.enter)="addProduct($event)"
        (keydown.escape)="clear($event)"
        [attr.aria-label]="
          'quickOrderForm.searchBoxLabel' | cxTranslate : { limit: limit }
        "
        aria-controls="results"
        aria-describedby="quickOrderFormInitialDescription"
        class="form-control"
        formControlName="product"
        [placeholder]="'quickOrderForm.placeholder' | cxTranslate"
        type="text"
        #quickOrderInput
      />
      <button
        *ngIf="form.get('product')?.value; else searchIcon"
        (click)="clear($event)"
        (keydown.enter)="clear($event)"
        [attr.aria-label]="'common.reset' | cxTranslate"
        class="quick-order-form-reset-icon"
      >
        <cx-icon [type]="iconTypes.RESET"></cx-icon>
      </button>
      <ng-template #searchIcon>
        <button
          [attr.aria-label]="'common.search' | cxTranslate"
          class="quick-order-form-search-icon"
          tabindex="-1"
        >
          <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
        </button>
      </ng-template>
      <span
        *ngIf="!(canAddProduct() | async) && form.get('product')?.dirty"
        class="list-limit-reached-text"
        role="alert"
      >
        {{ "quickOrderForm.listLimitReached" | cxTranslate }}
      </span>
    </div>
    <div
      *ngIf="isResultsBoxOpen()"
      class="quick-order-results"
      role="dialog"
      id="results"
    >
      <ul
        *ngIf="results.length"
        class="quick-order-results-products"
        role="listbox"
      >
        <li
          *ngFor="let product of results; let i = index"
          class="quick-order-results-product-container"
        >
          <button
            (blur)="onBlur($event)"
            (mousedown)="onAdd(product, $event)"
            (keydown.arrowdown)="focusNextChild($event)"
            (keydown.arrowup)="focusPreviousChild($event)"
            (keydown.enter)="onAdd(product, $event)"
            (keydown.escape)="clear($event)"
            [class.has-media]="
              config?.quickOrder?.searchForm?.displayProductImages
            "
            class="quick-order-results-product"
            role="option"
          >
            <cx-media 
              *ngIf="config?.quickOrder?.searchForm?.displayProductImages && ((product.servicePart && product.images?.PRIMARY) || !product.servicePart); else spGearThumb" 
              [container]="product.images?.PRIMARY"
              [alt]="product.name"
              format="thumbnail"
              class="media"
              role="presentation"></cx-media>
            <ng-template #spGearThumb>
              <div class="sp-gear-thumb">
                <img src="../../../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear">
              </div>
            </ng-template>
            <div
              class="name"
              [innerHTML]="product.name"
            ></div>
            <span class="id">
              {{
                (product.servicePart ? "quickOrderForm.idPart" : "quickOrderForm.id")
                  | cxTranslate
                    : {
                      id: product.displayModelNumber || product.code
                    }
              }}
            </span>
            <span class="price" *ngIf="product.price?.formattedValue">
              {{ product.price?.formattedValue }}
              <span class="quick-order-form__msrp">
                {{ (product.servicePart ? "quickOrderForm.mslp" : "quickOrderForm.msrp") | cxTranslate }}
              </span>
            </span>
          </button>
        </li>
      </ul>
      <span
        *ngIf="noResults"
        class="quick-order-no-results"
      >
        {{ "quickOrderForm.noResults" | cxTranslate }}
      </span>
    </div>
  </form>
  <label
    aria-live="polite"
    id="quickOrderFormInitialDescription"
    aria-atomic="true"
    class="cx-visually-hidden"
  >
    {{
      results.length
        ? ("quickOrderForm.productsResults"
          | cxTranslate : { count: results.length })
        : ""
    }}
    {{ "quickOrderForm.initialDescription" | cxTranslate }}
  </label>
</div>
